require('../../modules/es.set');
require('../../modules/esnext.set.find');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Set', 'find');
